import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {AuthApiService} from "../../auth/auth-api.service";
import {Router} from "@angular/router";
import {FUIAlertService, FUISpinnersService} from "@fedelta-pos/ui";
import {ErrorHandlerService} from "../../../error-handler.service";
import {BatchJobService} from "../batch-job.service";
import {BatchJobData} from "../batch-job.data";
import FileSaver from "file-saver";
import {HttpClient} from "@angular/common/http";
import {catchError, first, Subscription, timer} from "rxjs";

@Component({
    selector: "fhm-plan-update-batch-job-page",
    styles: [":host {display: flex; width: 100%;}"],
    templateUrl: "./plan-update-batch-job-page.component.html",
    providers: [BatchJobService],
    standalone: false
})
export class PlanUpdateBatchJobPageComponent implements OnInit, OnDestroy {

    private readonly MAX_UPLOAD_FILE_SIZE = 10485760;

    @ViewChild("inputUploadFile", {read: ElementRef}) public inputUploadFile: ElementRef;

    gridData: BatchJobData[] = [];

    refreshSubscription: Subscription;

    constructor(
        private http: HttpClient,
        private auth: AuthApiService,
        private errorHandler: ErrorHandlerService,
        private spinnersService: FUISpinnersService,
        private alertService: FUIAlertService,
        private batchJobService: BatchJobService,
        private router: Router) {

    }

    ngOnInit(): void {
        this.load();
        this.initRefresh();
    }

    ngOnDestroy(): void {
        if (this.refreshSubscription) {
            this.refreshSubscription.unsubscribe();
        }
    }

    private initRefresh(): void {
        this.refreshSubscription = timer(3000).pipe(first()).subscribe(() => {
            this.load();
            this.initRefresh();
        });
    }

    async load(): Promise<void> {
        try {
            this.gridData = await this.batchJobService.getBatchJobs("plan-update");
        } catch (error) {
            this.errorHandler.handleErrorResponse(error);
        }
    }



    done(): void {
        this.router.navigate(["/main/customer-instance-venue-search"]);
    }


    downloadReport(batchJob: BatchJobData): void {
        if (batchJob.status !== "Completed") {
            this.alertService.showError("fhm.common.prompt.unknownError.heading",
                "'Batch job has not completed'").subscribe(() => {
            });
        } else {
            this.spinnersService.open();
            this.http.get("/fonzie/batch-job-download/" + batchJob.id, {
                headers: this.auth.getHttpHeaderOptions(),
                responseType: "blob"
            })
                .pipe(catchError((error) => {
                    return this.errorHandler.handleError(error);
                }))
                .subscribe(data => {
                    FileSaver.saveAs(data,  "results.csv");
                    this.spinnersService.close();
                });
        }
    }


    uploadFileClick(): void {
        this.inputUploadFile.nativeElement.click();
    }

    inputUploadClick(event: MouseEvent): void {
        event.stopPropagation();
    }

    fileSelected(event: Event): void {
        const fileList: FileList = (<HTMLInputElement>event.target).files;
        if (fileList && fileList.length > 0) {
            try {
                const file: File = fileList[0];
                if (file.size > this.MAX_UPLOAD_FILE_SIZE) {
                    this.alertService.showError("fhm.contract.alert.uploadContractSizeLimit.title",
                        "fhm.contract.alert.uploadContractSizeLimit.message").subscribe(() => {
                    });
                    return;
                }
                this.uploadFile(file);
            } finally {
                (<HTMLInputElement>event.target).value = null;
            }
        }
    }

    async uploadFile(file): Promise<void> {
        this.spinnersService.open();
        try {
            await this.batchJobService.uploadFile("plan-update", file);
            // await this.model.refresh();
            this.spinnersService.close();
            await this.load();
        } catch (e) {
            this.spinnersService.close();
            this.errorHandler.handleErrorResponse(e);
        }
    }

}
